import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { CreateIndicatorCalculationGQL } from "../../generated/graphql/sustainability/create-IndicatorCalculation.graphql";
import { DeleteIndicatorCalculationGQL } from "../../generated/graphql/sustainability/delete-indicatorCalculation.graphql";
import { GetIndicatorCalculationsGQL } from "../../generated/graphql/sustainability/get-indicatorCalculation.graphql";
import {
  CreateIndicatorCalculationMutation,
  CreateIndicatorCalculationMutationVariables,
} from "../../generated/graphql/sustainability/create-IndicatorCalculation.graphql";
import { GetIndicatorCalculationsQuery } from "../../generated/graphql/sustainability/get-indicatorCalculation.graphql";
import { ApolloQueryResult } from "@apollo/client/core";
import {
  UpdateIndicatorCalculationGQL,
  UpdateIndicatorCalculationMutation,
  UpdateIndicatorCalculationMutationVariables,
} from "src/generated/graphql/sustainability/update-indicatorCalculation.graphql";

export interface DeleteIndicatorCalculationDto {
  id: number;
}

@Injectable({
  providedIn: "root",
})
export class IndicatorCalculationService {
  constructor(
    private createIndicatorCalculationGQL: CreateIndicatorCalculationGQL,
    private deleteIndicatorCalculationGQL: DeleteIndicatorCalculationGQL,
    private updateIndicatorCalculationGQL: UpdateIndicatorCalculationGQL,
    private getIndicatorCalculationsGQL: GetIndicatorCalculationsGQL,
  ) {}

  createIndicatorCalculation(
    variables: CreateIndicatorCalculationMutationVariables,
  ): Observable<CreateIndicatorCalculationMutation> {
    return this.createIndicatorCalculationGQL.mutate(variables).pipe(
      map((result) => result.data),
      catchError((error) =>
        throwError(
          () => new Error("Failed to create indicator calculation: " + error),
        ),
      ),
    );
  }

  deleteIndicatorCalculation(id: number): Observable<boolean> {
    return this.deleteIndicatorCalculationGQL
      .mutate({
        id: { id },
      })
      .pipe(
        map((result) => result.data.deleteIndicatorCalculation),
        catchError((error) =>
          throwError(
            () => new Error("Failed to delete indicator calculation: " + error),
          ),
        ),
      );
  }

  updateIndicatorCalculation(
    variables: UpdateIndicatorCalculationMutationVariables,
  ): Observable<UpdateIndicatorCalculationMutation> {
    return this.updateIndicatorCalculationGQL
      .mutate({
        id: variables.id,
        data: variables.data,
      })
      .pipe(
        map((result) => result.data),
        catchError((error) =>
          throwError(
            () => new Error("Failed to update indicator calculation: " + error),
          ),
        ),
      );
  }

  getIndicatorCalculations(): Observable<GetIndicatorCalculationsQuery> {
    return this.getIndicatorCalculationsGQL.watch().valueChanges.pipe(
      map((result) => result.data),
      catchError((error) =>
        throwError(
          () => new Error("Failed to fetch indicator calculations: " + error),
        ),
      ),
    );
  }
}
